// extracted by mini-css-extract-plugin
export default {"title":"styles_title__TJp6N","subTitle":"styles_subTitle__ivniQ","text":"styles_text__L7FkQ","liItem":"styles_liItem__O3nk2","ul":"styles_ul__MA+OM","ol":"styles_ol__2aePm"};